export default __webpack_public_path__ + "static/media/Import_Round.6d2797a1.svg";